import styled from 'styled-components';

export const OnboardingBlock = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  min-height: 100dvh;
  display: flex;
  justify-content: space-between;
  gap: 20px;
  text-align: center;
  padding: 20px;

  .brand_logo {
    display: block;
    width: 148px;
    margin: 0 auto 25px;

    @media (min-width: 992px) {
      max-width: 200px;
      position: absolute;
      left: 20px;
      top: 20px;
      margin: 0;
    }

    img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }
`;

export const FormCol = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  .form-content {
    width: 100%;
    max-width: 450px;
    margin: 0 auto;
  }
`;
